import { ColDef } from 'ag-grid-community'
import { BaseCellComponent, DataForCell, FieldForCell, PropsForCell } from './base-cell.component'
import { ActionCellComponent, ActionCellProps } from './action-cell.component'
import { pipe } from 'lodash/fp'
import { withHeader } from '../headers/table-header.component'

export const withCell = <
  C extends BaseCellComponent<D, P, F>,
  D = DataForCell<C>,
  P = PropsForCell<C>,
  F extends keyof D = FieldForCell<C>,
>(cellRenderer: unknown, cellRendererParams: P) => (def: ColDef): ColDef => ({ ...def, cellRenderer, cellRendererParams })

export const actionColumn = <T>(filterGroup: string, props: ActionCellProps<T>) =>
  pipe(withHeader<T>({ filterGroup }), withCell<ActionCellComponent<T>>(ActionCellComponent, props))({
    editable: false,
    minWidth: 150,
    width: 75,
    pinned: 'right',
    resizable: false,
    suppressMovable: true,
  })
